import { useState } from 'react'
import { ErrorDeApi, solicitar } from '@nucleo/api/cliente'
import { guardarCredencial, type ModoDeIdentidad } from '@nucleo/sesion'
import { Boton } from '@ui/primitivas/Boton'
import { Campo } from '@ui/primitivas/Campo'

/** Motivos con los que el servidor devuelve a la portada tras un ingreso ChileSST no completado. */
const AVISOS_DE_INGRESO: Record<string, string> = {
  cancelado: 'El ingreso se canceló antes de terminar. Puedes intentarlo de nuevo.',
  fallido: 'No fue posible confirmar tu identidad con ChileSST. Vuelve a ingresar; si se repite, revisa que tu cuenta tenga Atalaya habilitado.',
  no_disponible: 'El servicio de ingreso no respondió. Espera unos minutos e intenta nuevamente.',
}

function Marca() {
  return (
    <div className="sst-ingreso-marca">
      <img src="/chilesst/chilesst-mark-dark-bg.svg" alt="" width="40" height="40" />
      <span className="sst-marca-texto"><b>Chile<span>SST</span></b><small>Atalaya</small></span>
    </div>
  )
}

export function PantallaAcceso(props: { alEntrar: () => void; modo: ModoDeIdentidad }) {
  const [clave, setClave] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [trabajando, setTrabajando] = useState(false)
  const motivo = new URLSearchParams(window.location.search).get('ingreso')
  const aviso = motivo ? AVISOS_DE_INGRESO[motivo] : undefined

  const entrar = async () => {
    setError(null)
    if (!clave.trim()) {
      setError('Ingresa la clave de acceso de tu organización.')
      return
    }
    setTrabajando(true)
    guardarCredencial(clave.trim())
    try {
      await solicitar<{ organizacion_id: string }>('GET', '/api/yo')
      props.alEntrar()
    } catch (e) {
      window.sessionStorage.removeItem('atalaya.credencial')
      setError(e instanceof ErrorDeApi && e.estado === 401 ? 'Clave no reconocida.' : 'No fue posible validar la clave. Revisa que el servidor esté disponible.')
    } finally {
      setTrabajando(false)
    }
  }

  if (props.modo === 'chilesst') {
    return (
      <main className="sst-ingreso font-base text-cuerpo">
        <section className="sst-ingreso-tarjeta sst-entrada" aria-labelledby="titulo-ingreso">
          <Marca />
          <p className="cs-eyebrow">Matriz IPER asistida</p>
          <h1 id="titulo-ingreso">Identifica peligros y evalúa riesgos con Atalaya</h1>
          <p className="sst-ingreso-texto">Ingresa con tu cuenta ChileSST. Usarás Atalaya con los permisos de tu organización.</p>
          <ol className="sst-ingreso-pasos" aria-label="Qué harás en Atalaya">
            <li>Defines el alcance del centro de trabajo</li>
            <li>Describes el proceso y validas las tareas</li>
            <li>Revisas peligros, evaluación y medidas</li>
            <li>Oficializas y descargas la MIPER</li>
          </ol>
          {aviso ? <p role="alert" className="sst-ingreso-aviso">{aviso}</p> : null}
          <a href="/api/sesion/iniciar" className="sst-cta">Entrar con tu cuenta ChileSST</a>
          <a href="https://chilesst.cl/#modulos" className="sst-ingreso-volver">Volver a herramientas</a>
        </section>
      </main>
    )
  }

  return (
    <main className="sst-ingreso font-base text-cuerpo">
      <form
        className="sst-ingreso-tarjeta sst-entrada grid gap-4"
        aria-labelledby="titulo-ingreso"
        onSubmit={(e) => {
          e.preventDefault()
          void entrar()
        }}
      >
        <Marca />
        <div className="grid gap-1">
          <p className="cs-eyebrow">Matriz IPER asistida</p>
          <h1 id="titulo-ingreso">Ingreso con clave de organización</h1>
          <p className="sst-ingreso-texto">
            Sentinel investiga lo que ya pasó. Atalaya vigila lo que puede pasar: Atalaya propone la matriz completa y tú la validas.
          </p>
        </div>
        <div className="rounded-lg bg-superficie p-3 text-texto">
          <Campo etiqueta="Clave de acceso de la organización" tipo="password" valor={clave} alCambiar={setClave} requerido autoFoco ayuda="Prototipo: una clave por organización (ver backend/.env.ejemplo)." {...(error ? { error } : {})} />
        </div>
        <Boton tipo="submit" trabajando={trabajando}>Entrar</Boton>
      </form>
    </main>
  )
}
